"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
(0, jquery_1.default)(document).ready(function () {
    if (namespace_1.default && !namespace_1.default.initialized) {
        namespace_1.default.initialized = true;
        new namespace_1.default.setup.init().start();
    }
});
namespace_1.default.namespace.extend('setup.init', function () {
    /*
        At the start of every spine-based application, we need to find out how many apaOuterFrames are declared and to check the device.
        This function initializes the loading process afterwards.
    */
    this.items = [];
    this.visuals = [];
    /*
        this.start does the following:
            1.) Check device infos
            2.) Check how many apaOuterFrames are available on the site + saves this.items and this.visuals
            3.) Create some config Params that are needed for every project (depending on this.visuals)
            4.) Load the client.spine.params.js
    */
    this.start = function () {
        var _this = this;
        var defArr = [jquery_1.default.Deferred(), jquery_1.default.Deferred(), jquery_1.default.Deferred(), jquery_1.default.Deferred()];
        namespace_1.default.setup.device.check(defArr[0]);
        this.check(defArr[1]);
        this.createVisuals(defArr[2]);
        new namespace_1.default.setup.params().load(defArr[3]); // load params that may be different in a client implementation
        jquery_1.default.when.apply(this, defArr).then(function () {
            new namespace_1.default.observer.stylefills().init(_this.items.length);
            _this.load();
        });
    };
    /*
        We need to get the id and the codebase of the apaOuterFrame to push them it into the variable this.items.

        The variables

            this.items
            this.visuals

        are set here.
    */
    this.check = function (deferred) {
        var _this = this;
        var idArray = [];
        Array.from(document.getElementsByClassName('apaOuterFrame')).forEach(function (el, index) {
            var id = (0, jquery_1.default)(el).attr('id');
            if (idArray.indexOf(id) > -1) {
                id = id + index;
                el.id = id;
            }
            idArray.push(id);
            var item = {
                id: id,
                codebase: (((0, jquery_1.default)(el).attr('data-package')) ? (0, jquery_1.default)(el).attr('data-package') : null),
                namespace: (((0, jquery_1.default)(el).attr('data-package')) ? (0, jquery_1.default)(el).attr('data-package').split('.')[0] : false),
            };
            _this.items.push(item);
            if (item.codebase && jquery_1.default.inArray(item.codebase.split('.')[0], _this.visuals) == -1) {
                _this.visuals.push(item.codebase.split('.')[0]);
            }
            (0, jquery_1.default)(el).addClass('apa' + namespace_1.default.formatting.firstUpperCase(item.namespace));
        });
        deferred.resolve();
    };
    /*
        We need to create the base namespace
    */
    this.createVisuals = function (deferred) {
        this.visuals.forEach(function (visual) {
            // @ts-ignore // TODO
            if (!namespace_1.default.visual[visual])
                namespace_1.default.visual[visual] = {};
            // @ts-ignore // TODO
            if (!namespace_1.default.visual[visual].config)
                namespace_1.default.visual[visual].config = {};
            if (!namespace_1.default.visual[visual].config.frame)
                namespace_1.default.visual[visual].config.frame = {};
            // @ts-ignore // TODO
            if (!namespace_1.default.visual[visual].config.frameSetting)
                namespace_1.default.visual[visual].config.frameSetting = false;
        });
        deferred.resolve();
    };
    /*
        Load:

            - apa css files
            - apa configs
            - apa packages
            - client css
            - client configs
            - client scripts
    */
    this.load = function () {
        var _this = this;
        var defApaConfig = jquery_1.default.Deferred();
        var defClientConfig = jquery_1.default.Deferred();
        var defApaCss = jquery_1.default.Deferred();
        var defClientCss = jquery_1.default.Deferred();
        var defPackageSetup = jquery_1.default.Deferred();
        var defClientScripts = jquery_1.default.Deferred();
        var tPackageSetup = new namespace_1.default.setup.scripts.packages();
        tPackageSetup.load(tPackageSetup.getPackages(this.items), 'apa', defPackageSetup);
        new namespace_1.default.setup.configs().load(this.visuals, 'apa', defApaConfig);
        defApaConfig.then(function () {
            new namespace_1.default.setup.configs().load(_this.visuals, 'client', defClientConfig);
        });
        new namespace_1.default.setup.scripts.client().load(this.visuals, 'client', defClientScripts);
        new namespace_1.default.setup.css().append(this.visuals, 'apa', defApaCss);
        new namespace_1.default.setup.css().append(this.visuals, 'client', defClientCss);
        jquery_1.default.when.apply(this, [defApaConfig, defClientConfig, defApaCss, defClientCss, defPackageSetup, defClientScripts]).then(function () { return _this.loadLanguage(); });
    };
    /*
        Third Step is to load the language, we need the apa config and client config to know which language should be loaded
    */
    this.loadLanguage = function () {
        var _this = this;
        var defObj = jquery_1.default.Deferred();
        new namespace_1.default.setup.languages().load(this.visuals, defObj);
        jquery_1.default.when(defObj).then(function () { return _this.init(); });
    };
    /*
        Checks url params for visuals and initialization of the items
    */
    this.init = function () {
        namespace_1.default.url.getOverallParams(this.visuals);
        var tItem = new namespace_1.default.setup.items();
        tItem.data = this.items;
        tItem.init();
    };
});
